import * as type from './type';
export default {
    [type.SET_LIMIT_RULES](state, limitRules) {
        state.limitRules = limitRules;
    },

    [type.SET_LIMIT_RULE_DETAIL](state, limitRuleDetail) {
        state.limitRuleDetail = limitRuleDetail;
    },

    [type.SET_WARE_LISTS](state, wareLists) {
        state.wareLists = wareLists;
    },

    [type.SET_AREA_LISTS](state, areaLists) {
        state.areaLists = areaLists;
    },

    [type.SET_SELECTED_WARE](state, selectedWare) {
        state.selectedWare = selectedWare;
    },

    [type.SET_FORM](state, form) {
        state.form = form;
    },

    [type.SET_SELECTED_AREA](state, selectedArea) {
        state.selectedArea = selectedArea;
    },

    [type.SET_REFRESH_WARE](state, isRefreshWare) {
        state.isRefreshWare = isRefreshWare;
    },
}


// WEBPACK FOOTER //
// ./src/store/limit-sale/mutations.js